export default "/_next/static/images/app_mockup-9b3a044e6fbf348edeb5f4a829bf3926.png";